import { SplideSlide } from '@splidejs/react-splide'
import { useParams } from 'react-router'
import { Link } from 'react-router-dom'
import { useSponsorTypesContext } from '../../context/sponsor-types/SponsorTypeProvider'
import SilderSponsersBanners from '../../../core/components/SilderSponsersBanners'

export default function SliderGoldSponsorsBanners() {
  const { lng } = useParams()
  const { sponsorTypesState } = useSponsorTypesContext()

  if (sponsorTypesState.isLoading) {
    return (
      <div
        data-aos="fade-up"
        className="app-container"
      >
        <div className="h-[190px] animate-pulse bg-muted-400"></div>
      </div>
    )
  }

  if (sponsorTypesState.types?.gold?.have_sponsors)
    return (
      <SilderSponsersBanners>
        {sponsorTypesState.types?.gold?.sponsors?.map((sponsor) => (
          <SplideSlide key={sponsor.id}>
            <Link
              to={`/${lng}/sponsors/${sponsor.slug}`}
              className="flex flex-col items-start justify-start"
            >
              <div
                title={sponsorTypesState.types?.gold[`name_${lng}`]}
                className="max-h-[190px] overflow-hidden border-2 border-info bg-muted-300"
              >
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}/storage/${sponsor.banner}`}
                  alt={sponsor[`name_${lng}`]}
                  className="h-full w-full object-contain"
                />
              </div>
            </Link>
          </SplideSlide>
        ))}
      </SilderSponsersBanners>
    )
}
